import { render, staticRenderFns } from "./OrderedGiftCards.vue?vue&type=template&id=1cbd1280&scoped=true&"
import script from "./OrderedGiftCards.vue?vue&type=script&lang=js&"
export * from "./OrderedGiftCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd1280",
  null
  
)

export default component.exports